// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IAssessmentPlanningApi,
  IAssessmentPlanningApiRequest,
  IAssessmentPlanningApiGetDetailAttrs,
  IAssessmentPlanningApiDetailResponse,
} from 'interfaces/back-office/assessment/planning/planning-api.interface'

// Constant
import { ApiConstantHc, ApiConstantHcBase } from 'constant'

// Utils
import { axios_renderHcUrl } from 'utils'

export class AssessmentPlanningApi extends BaseApi<IAssessmentPlanningApi> implements IAssessmentPlanningApiRequest {
  readonly url = ApiConstantHc.ASSESSMENT_PLANNING_URL
  private assessmentPlanningUrl = axios_renderHcUrl(this.url, ApiConstantHcBase.ASSESSMENT)

  /**
   * @description Get assessment planning detail
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAssessmentPlanningApiGetDetailAttrs} payload
   *
   * @return {Promise<IAssessmentPlanningApiDetailResponse>} Promise<IAssessmentPlanningApiDetailResponse>
   */
  async assessmentPlanning_getDetail(
    payload: IAssessmentPlanningApiGetDetailAttrs,
  ): Promise<IAssessmentPlanningApiDetailResponse> {
    return this.POST(`${this.assessmentPlanningUrl}/${payload.params.assessmentId}`, {}, { ...payload.requestConfig })
  }
}
